import { createFeatureSelector, createSelector } from '@ngrx/store';
import { commonIdTopicFeatureKey, State } from 'src/app/reducers/common-id/common-id-topic.reducer';

const selectCommonIdTopicState = createFeatureSelector<State>(commonIdTopicFeatureKey);

export const getCommonIdTopic = createSelector(selectCommonIdTopicState, state => state.commonIdGetTopicResult);
